module.exports = __webpack_public_path__ + "img/remote_schema.d7c94ea3.png";